import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { getHomeCategories, createCategory } from "../../apis/admin";

const AdminCategoryManager = () => {
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newCategory, setNewCategory] = useState({
    name: "",
    level: "",
  });
  const [imageFile, setImageFile] = useState(null);
  const [cookies] = useCookies(["access_token"]);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  let navigate = useNavigate();

  useEffect(() => {
    if (!cookies.access_token) {
      navigate("/");
    } else {
      const fetchCategories = async () => {
        try {
          const response = await getHomeCategories(cookies.access_token);
          setCategories(response.data.data); // Lấy dữ liệu từ kết quả trả về
        } catch (error) {
          console.error("Lỗi khi lấy danh mục:", error);
        }
      };

      fetchCategories();
    }
  }, [cookies.access_token, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCategory({
      ...newCategory,
      [name]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
    }
  };

  const handleSaveCategory = async () => {
    const formData = new FormData();
    if (imageFile) {
      formData.append("image", imageFile);
    }
    formData.append("name", newCategory.name);
    formData.append("level", newCategory.level);

    try {
      const result = await createCategory(formData, cookies.access_token);
      if (result.status === 200) {
        setNewCategory({ name: "", level: "" });
        setImageFile(null);
        setShowModal(false);
        setSuccess("Category created successfully!");

        // Fetch the updated categories list
        const updatedCategories = await getHomeCategories(cookies.access_token);
        setCategories(updatedCategories.data.data);
      }
    } catch (error) {
      setError(`Error occurred: ${error.response?.data?.message || error.message}`);
    }
  };

  return (
    <div className="admin-category-manager">
      <h3>Category Management</h3>
      <Button variant="primary" onClick={() => setShowModal(true)}>
        Create Category
      </Button>

      {success && <Alert variant="success">{success}</Alert>}
      {error && <Alert variant="danger">{error}</Alert>}

      <table className="table mt-3">
        <thead>
          <tr>
            <th>Image</th>
            <th>Name</th>
            <th>Level</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category, index) => (
            <tr key={index}>
              <td>
                {category.imageURL ? (
                  <img
                    src={category.imageURL}
                    alt={category.name}
                    style={{ width: "50px", height: "50px" }}
                  />
                ) : (
                  <span>No Image</span> // Handle the case where imageURL is undefined
                )}
              </td>
              <td>{category.name}</td>
              <td>{category.level}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formCategoryImage">
              <Form.Label>Image</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
              {imageFile && (
                <img
                  src={URL.createObjectURL(imageFile)}
                  alt="Preview"
                  style={{ width: "100px", height: "100px", marginTop: "10px" }}
                />
              )}
            </Form.Group>
            <Form.Group controlId="formCategoryName">
              <Form.Label>Category Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newCategory.name}
                onChange={handleInputChange}
              />
            </Form.Group>
            <Form.Group controlId="formCategoryLevel">
              <Form.Label>Level</Form.Label>
              <Form.Control
                type="number"
                name="level"
                value={newCategory.level}
                onChange={handleInputChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveCategory}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminCategoryManager;
